import { render } from "./ReceiverOverview.vue?vue&type=template&id=6ee9867c&scoped=true"
import script from "./ReceiverOverview.vue?vue&type=script&lang=js"
export * from "./ReceiverOverview.vue?vue&type=script&lang=js"

import "./ReceiverOverview.vue?vue&type=style&index=0&id=6ee9867c&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ee9867c"],['__file',"src/scripts/view/review/components/receiver/ReceiverOverview.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6ee9867c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6ee9867c', __exports__)) {
    api.reload('6ee9867c', __exports__)
  }
  
  module.hot.accept("./ReceiverOverview.vue?vue&type=template&id=6ee9867c&scoped=true", () => {
    api.rerender('6ee9867c', render)
  })

}


export default __exports__